import { render, staticRenderFns } from "./CreateOrderModal.vue?vue&type=template&id=341defc6&"
import script from "./CreateOrderModal.vue?vue&type=script&lang=js&"
export * from "./CreateOrderModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateOrderModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports